import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import Respondent from "./Respondent";
import Household from "./Respondent/Household";

RespondentsList.propTypes = {
  expired: PropTypes.bool,
};

export default function RespondentsList({
  signupItemID,
  respondents,
  maxSlots,
  slotsAvailable,
  fundIt,
  amount,
  hasSignupLevelCost,
}) {
  const [removalType, setRemovalType] = React.useState(); // one of the userTypes or "slot"
  const hasSignupCost = fundIt?.hasSignupCost || hasSignupLevelCost;

  const hasRespondents =
    Array.isArray(respondents) && respondents.length && respondents.length > 0;

  const getHouseholdID = (respondent) => {
    let isHousehold = respondent.isHousehold;
    if (!isHousehold) return;

    let householdID = respondent.householdRespondents[0].householdID;
    return householdID;
  };

  if (!hasRespondents) return null;

  return (
    <Wrapper>
      <List data-cy="signup-respondents-list">
        <Spacer />
        {respondents?.map((user, i) => {
          return user.isHousehold ? (
            <Household
              key={getHouseholdID(user)}
              highlight={i % 2 === 0}
              household={user}
              signupItemID={signupItemID}
              hasSignupCost={hasSignupCost}
              removalType={removalType}
              setRemovalType={setRemovalType}
            />
          ) : (
            <Respondent
              key={user.userID}
              highlight={i % 2 === 0}
              signupItemID={signupItemID}
              slotsAvailable={slotsAvailable}
              maxSlots={maxSlots}
              user={user}
              hasSignupCost={hasSignupCost}
              setRemovalType={setRemovalType}
              removalType={removalType}
            />
          );
        })}
      </List>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const List = styled(motion.div)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  /* padding: 0 8px; */
`;

const Spacer = styled.div`
  height: 5px;
  width: 100%;
`;
